import { subYears } from 'date-fns';
import { useCallback, useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { Message } from '@app/app/_components/Message/Message';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { ViolationError } from '@app/lib/form/contracts/ViolationError';
import {
    MAX_AGE_SELECTED,
    MIN_AGE_SELECTED,
} from '@app/app/esales/life/_sections/LifeInsuranceWizardSection/helpers/businessValueConfig';
import { DatePickerLifeEE } from '@app/app/_components/DatePicker/DatePickerLifeEE';

interface Props {
    error?: ViolationError;
    value?: string;
    onChange?: (dob: string) => void;
}

export function DateOfBirthStep({ error, value, onChange }: Props) {
    const t = useTranslations();
    const today = new Date();

    const minDate = subYears(today, MAX_AGE_SELECTED);
    const maxDate = subYears(today, MIN_AGE_SELECTED);

    const defaultValue = useMemo(() => (value ? new Date(value) : undefined), [value]);

    const handleDateChange = useCallback(
        (date: Nullable<Date>) => {
            onChange?.(date?.toISOString() ?? '');
        },
        [onChange],
    );

    return (
        <div className="flex flex-col gap-4">
            <Paragraph isBold>{t('eshop.life.dateOfBirthLabel')}</Paragraph>
            <DatePickerLifeEE
                name="dateOfBirth"
                error={error}
                format="dd.MM.yyyy"
                placeholder={t('eshop.life.dateOfBirthPlaceholder')}
                defaultValue={defaultValue}
                initialViewDate={maxDate}
                minDate={minDate}
                maxDate={maxDate}
                yearRange={10}
                onChange={handleDateChange}
            />
            <Message variant="info">
                <div dangerouslySetInnerHTML={{ __html: t.raw('eshop.life.howOldAreYouDescription') }} />
            </Message>
        </div>
    );
}
